import '@trimble-oss/modus-icons-css/css/modus-icons-duotone.min.css';
import '@trimble-oss/modus-icons-css/css/modus-icons-fill.min.css';
import '@trimble-oss/modus-icons-css/css/modus-icons-regular.min.css';
import '@trimble-agentic-internal-npm-local/agentic-chat-ui/style.css';
import '@trimble-oss/moduswebcomponents/modus-wc-styles.css';
import ReactDOM from 'react-dom/client';
import './index.css';

import { EmbeddedApp } from './EmbeddedApp';
import './i18n';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(<EmbeddedApp />);
